import React from 'react';
import { Button } from 'react-bootstrap';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const TopBar = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/admin/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <div className="admin-topbar">
      <div>
        <h4 className="mb-0" style={{ color: '#2A2F35' }}>
          Panel de Administración
        </h4>
      </div>
      
      <div className="d-flex align-items-center gap-3">
        <span style={{ color: '#555' }}>
          <i className="fas fa-user-circle me-2"></i>
          {user?.email}
        </span>
        
        <Button
          variant="outline-danger"
          size="sm"
          onClick={handleLogout}
        >
          <i className="fas fa-sign-out-alt me-2"></i>
          Cerrar Sesión
        </Button>
      </div>
    </div>
  );
};

export default TopBar;
